import { Toaster as Sonner, type ToasterProps } from 'sonner'

export function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      className="toaster group [&_div[data-content]]:w-full"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'transparent',
          '--border-radius': '20px',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: 'shadow-float! font-sans! text-[13px]! px-4! py-3.5!',
          description: 'text-muted-foreground! text-xs!',
          actionButton:
            'rounded-full! bg-foreground! text-background! font-medium!',
          cancelButton: 'rounded-full! bg-secondary! text-foreground!',
        },
      }}
      {...props}
    />
  )
}
